import React from 'react';

export function SelectResourceItemSkeleton() {
  return (
    <div className="mx-2 flex cursor-pointer items-center gap-2 rounded-md px-2 py-2 lt:mx-4">
      <div className="mr-2 h-12 w-12 animate-pulse rounded-md bg-neutral100" />
      <div className="flex flex-1 flex-col justify-center gap-2">
        <div className="h-2 w-32 animate-pulse rounded-full bg-neutral100" />
        <div className="h-2 w-24 animate-pulse rounded-full bg-neutral100" />
      </div>
    </div>
  );
}
